import React from "react";

import "../Auth/auth.css";

import { withRouter } from 'react-router';
import queryString from 'query-string';

class Login extends React.Component {
  render() {
    let params = queryString.parse(this.props.location.search);
    let errorBoxClasses = "error-box";
    if (params['error'] !== undefined) {
      errorBoxClasses += " show";
    };
    let errorString = decodeURIComponent(params['error'] || '');

    return <div className="auth-container">
      <p className="large-title center-text">Login to your dark account</p>
      <div className={errorBoxClasses} id="error-text">{errorString}</div>
      <form action="/login" method="POST">
        <input type="text" placeholder="username" id="username" name="username" />
        <input type="password" placeholder="password" id="password" name="password" />
        <input type="hidden" id="redirect" name="redirect" value={params['redirect']||''} />
        <button type="submit">Login</button>
      </form>
      <p className="auth-links">Don't have account? <a href="/beta">Sign Up</a></p>
      <p className="auth-links">
      Forgot Password? <a href="/reset-password" onClick={this.forgotPassword}>Reset Password</a>
    </p>
    </div>;
  }
}

export default withRouter(Login);
